/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Person_MissingInputs */

const fr_error_person_missing = /** @type {(inputs: Error_Person_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce collaborateur n’est plus disponible. Actualisez la liste.`)
};

const en_error_person_missing = /** @type {(inputs: Error_Person_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person is no longer available. Refresh the list.`)
};

/**
* | output |
* | --- |
* | "This person is no longer available. Refresh the list." |
*
* @param {Error_Person_MissingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_person_missing = /** @type {((inputs?: Error_Person_MissingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Person_MissingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_person_missing(inputs)
	return fr_error_person_missing(inputs)
});